/*
 * Authors: mariushirjanu
 * Created: 23/11/2023
 */
import { ErrorHandler, Injectable } from '@angular/core';
import { LoggerService } from './logger/logger.service';
import { LogType } from './logger/remote-logger-data.service';

@Injectable()
export class GaErrorHandlerService implements ErrorHandler {
  constructor(
    private loggerService:LoggerService
  ) {
    /***/
  }

  /**
   * @name handleError
   * @description WARN: Until AngularJs is completely removed, this method is not able to catch initialisation time errors
   * @param error
   */
  public handleError(error:LogType) {
    this.loggerService.error(error);
  }
}